var _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpecialCaseNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.732 10.724H9.228V12.22H7.732V10.724ZM7.732 4.74H9.228V9.228H7.732V4.74ZM8.47252 1C4.34356 1 1 4.35104 1 8.48C1 12.609 4.34356 15.96 8.47252 15.96C12.609 15.96 15.96 12.609 15.96 8.48C15.96 4.35104 12.609 1 8.47252 1ZM8.48 14.464C5.17384 14.464 2.496 11.7862 2.496 8.48C2.496 5.17384 5.17384 2.496 8.48 2.496C11.7862 2.496 14.464 5.17384 14.464 8.48C14.464 11.7862 11.7862 14.464 8.48 14.464Z",
    fill: "#BC0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.732 10.674H7.682V10.724V12.22V12.27H7.732H9.228H9.278V12.22V10.724V10.674H9.228H7.732ZM7.732 4.69H7.682V4.74V9.228V9.278H7.732H9.228H9.278V9.228V4.74V4.69H9.228H7.732ZM8.47252 0.95C4.31588 0.95 0.95 4.32349 0.95 8.48C0.95 12.6365 4.31588 16.01 8.47252 16.01C12.6365 16.01 16.01 12.6366 16.01 8.48C16.01 4.32339 12.6365 0.95 8.47252 0.95ZM8.48 14.414C5.20145 14.414 2.546 11.7585 2.546 8.48C2.546 5.20145 5.20145 2.546 8.48 2.546C11.7585 2.546 14.414 5.20145 14.414 8.48C14.414 11.7585 11.7585 14.414 8.48 14.414Z",
    stroke: "#3C419A",
    strokeOpacity: 0.7,
    strokeWidth: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6,
    cy: 13.2395,
    r: 4.26,
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8842 15.2802L17.32 11.8201L16.7044 11.2002L13.8842 14.0403L12.4956 12.6419L11.88 13.2618L13.8842 15.2802Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialCaseNotification);
export default __webpack_public_path__ + "static/media/special-case-notification.79f3b0375e2affc2774a55291d89c79a.svg";
export { ForwardRef as ReactComponent };